import React from 'react';
import { Icon as ReactIcon } from '@a-ui/react';
import { translate } from '../../i18n';
import { ITranslations } from '../../i18n/config';
import Link from '../Link';
import './style.scss';

export interface BackLinkProps {
  backAction: string | ((e: React.MouseEvent<HTMLButtonElement>) => void);
  backLabel: ITranslations;
}

const BackLink: React.FC<BackLinkProps> = ({ backAction, backLabel }) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (typeof backAction !== 'function') return;

    e.preventDefault();
    backAction(e);
  };

  return (
    <div className="ckp-m-back">
      {typeof backAction === 'string' && (
        <Link
          to={backAction}
          icon="ai-arrow-left-1"
          iconPlacement="left"
          iconScreenReaderText={translate('header.back.screenreaders')}
        >
          {translate(backLabel)}
        </Link>
      )}
      {typeof backAction === 'function' && (
        <button type="button" onClick={handleClick} className="a-link has-icon-left">
          <ReactIcon
            name="ai-arrow-left-1"
            screenReaderText={`${translate('header.back.screenreaders')}`}
          />
          {translate(backLabel)}
        </button>
      )}
    </div>
  );
};

export default BackLink;
